import Cookies from 'js-cookie';

const handler = ( $ ) => {

	// scroll to active filter
	if( $('.bookmarks-page-content').length ) {
		$('.bookmarks-page-content .nav-links').animate({
			scrollLeft: $('.bookmarks-page-content .is-active').offset().left - ($(window).width() / 2 ) + ( $('.bookmarks-page-content .is-active').outerWidth() / 2 )
		}, 300, 'swing');
	}

	const $bookmarsDiv = $('#bookmarks');

	// load bookrmarks
	const loadPosts = function( again = false ) {

		const bookmarksType = $('.page-template-page-tpl-bookmarks .nav-links-wrapper a.is-active').data('type');

		let offset = 0;

		if( ! again ) {
			offset = $bookmarsDiv.find('article').length;
		}

		$.ajax( {
			url: themeVars.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'fp_load_bookmarks',
				type: bookmarksType,
				offset: offset,
				nonce: Cookies.get( 'wordpress_pen_ajax_nonce' ),
			},
			beforeSend: function () {
				$bookmarsDiv.addClass( 'is-loading' );
			},
			success: function ( answer ) {
				$bookmarsDiv.removeClass( 'is-loading' );

				if( again ) {
					$bookmarsDiv.html( answer.data.html );
				} else {

					if( answer.data.hide_load_more ) {
						$bookmarsDiv.find('.pagination-link').remove();
					}
					
					$bookmarsDiv.find('.posts-holder').append( answer.data.html );
				}
				
			}
		});

	}

	// switch between bookmarks types
	$('.page-template-page-tpl-bookmarks .nav-links-wrapper a').on( 'click', function( e ) {
		e.preventDefault();

		const $link = $(this),
		$all_links = $link.parent().find('a'),
		type = $link.data('type');

		$all_links.not( $link ).removeClass('is-active');
		$link.addClass('is-active');

		history.pushState({},'',`?type=${type}`);

		loadPosts( true );

	});

	// load more bookmarks
	$( document ).on( 'click', '.load-more-bookmarks', function( e ) {
		e.preventDefault();
		loadPosts();

	});

	/**
	 * Boormark: add / remove
	 */
	$( document ).on( 'click', '.bookmark-toggle', function( e ) {
		e.preventDefault();

		if( ! themeVars.is_user_logged_in ) {
			return false;
		}

		const $link = $(this),
		post_type = $link.data('post-type'),
		post_id = $link.data('id'),
		remove = $link.data('remove');

		$.ajax( {
			url: themeVars.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'fp_toggle_bookmark',
				post_type: post_type,
				post_id: post_id,
				nonce: Cookies.get( 'wordpress_pen_ajax_nonce' ),
			},
			success: function ( answer ) {

				if( remove !== undefined ) {
					$link.parents( remove ).fadeOut( 'fast', function() {
						$(this).remove();
					});
				}

				if( answer.data.result == 'deleted' ) {
					$link.addClass('inactive');
				} else {
					$link.removeClass('inactive');
				}
				
			}
		});

	});

};

export default ( ( $ ) => $( handler ) )( jQuery );
